<template>
    <div id="Hotspot">

        <Head @isLoginOpen="isLoginOpen" />
        <Login @isLoginOpen="isLoginOpen" v-if="isLogin" />
        <div class="hotspot">
            <div class="Main">
                <div class="navTop">
                    <div class="hNav">
                        <div class="hNTop">
                            <i></i>
                            <!-- <img src="../assets/Hotspot/00.png" />热点动态 -->
                            热点动态
                            <i></i>
                        </div>
                        <ul>
                            <li :class="{ active: navI == 0 }" @click="getNav(0)">
                                <img :src="navI == 0
                                    ? require('../assets/Hotspot/新闻 (2).png')
                                    : require('../assets/Hotspot/新闻 (2) 拷贝.png')
                                    " alt />行业动态
                            </li>
                            <li :class="{ active: navI == 1 }" @click="getNav(1)">
                                <img :src="navI == 1
                                    ? require('../assets/Hotspot/新闻 (3) 拷贝.png')
                                    : require('../assets/Hotspot/新闻 (3).png')
                                    " alt />国内动态
                            </li>
                            <li :class="{ active: navI == 2 }" @click="getNav(2)" class="padTo">
                                <img :src="navI == 2
                                    ? require('../assets/Hotspot/新闻 (1) 拷贝.png')
                                    : require('../assets/Hotspot/新闻 (1).png')
                                    " alt />国外动态
                            </li>
                        </ul>
                    </div>
                    <div class="news">
                        <p>热点推荐</p>
                        <ul class="rec">
                            <li v-for="(item, i) in news1" :key="i" @click="toDel(item)">
                                <img :src="item.imgurl" alt />
                            </li>
                        </ul>
                    </div>
                    <!-- <div class="banner">
            <el-carousel height="3rem">
              <el-carousel-item v-for="item in Img" :key="item">
                <img :src="item" />
              </el-carousel-item>
            </el-carousel>
          </div>-->
                </div>
                <div class="hMain">
                    <div class="hMtop">
                        {{ hMtop[navI] }}
                        <img src="../assets/Hotspot/02.png" />
                    </div>
                    <div class="hMList">
                        <ul v-show="navI == 0">
                            <li v-for="(item, index) in hotspot[0]" :key="index"
                                @click="addLink(index, 'a0', hotspot[0][index].ID)">
                                <div>
                                    <router-link target="_blank" :to="`/Hotspot/HotDetails?newsID=${item.ID}`"
                                        class="hMTitle a0">
                                        <div ref="tit" :class="currentIdx == index ? 'activeColor' : ''">
                                            <!-- <div ref="tit" :class="[currentIdx==index?'activeColor':'',currentCheckIdx==index?'activeColor1':'']"> -->
                                            <!-- <i :class="[currentIdx==index?'active':'',currentCheckIdx==index?'active1':'']"></i> -->
                                            <i class="active"></i>
                                            <!-- {{item.Details}} -->
                                            {{ item.Title }}
                                        </div>
                                        <span>{{ item.Date }}</span>
                                    </router-link>
                                </div>
                            </li>
                        </ul>
                        <ul v-show="navI == 1">
                            <li v-for="(item, index) in hotspot[1]" :key="index"
                                @click="addLink(index, 'a1', hotspot[1][index].ID)">
                                <div>
                                    <router-link target="_blank" :to="`/Hotspot/HotDetails?newsID=${item.ID}`"
                                        class="hMTitle a1">
                                        <div ref="tit" :class="currentIdx == index ? 'activeColor' : ''">
                                            <!-- <div ref="tit" :class="[currentIdx==index?'activeColor':'',currentCheckIdx==index?'activeColor1':'']"> -->
                                            <!-- <i :class="[currentIdx==index?'active':'',currentCheckIdx==index?'active1':'']"></i> -->
                                            <i class="active"></i>
                                            <!-- {{item.Details}} -->
                                            {{ item.Title }}
                                        </div>
                                        <span>{{ item.Date }}</span>
                                    </router-link>
                                </div>
                            </li>
                        </ul>
                        <ul v-show="navI == 2">
                            <li v-for="(item, index) in hotspot[2]" :key="index"
                                @click="addLink(index, 'a2', hotspot[s2][index].ID)">
                                <div>
                                    <router-link target="_blank" :to="`/Hotspot/HotDetails?newsID=${item.ID}`"
                                        class="hMTitle a2">
                                        <div ref="tit" :class="currentIdx == index ? 'activeColor' : ''">
                                            <!-- <div ref="tit" :class="[currentIdx==index?'activeColor':'',currentCheckIdx==index?'activeColor1':'']"> -->
                                            <!-- <i :class="[currentIdx==index?'active':'',currentCheckIdx==index?'active1':'']"></i> -->
                                            <i class="active"></i>
                                            <!-- {{item.Details}} -->
                                            {{ item.Title }}
                                        </div>
                                        <span>{{ item.Date }}</span>
                                    </router-link>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="hMFoot">
                        <el-pagination style="text-align: right;height: 0.45rem;" @current-change="getNav()"
                            :current-page.sync="Page1" layout="prev, pager, next, jumper" :total="total1"></el-pagination>
                    </div>
                </div>
                <!-- <HotDetails v-else /> -->
            </div>
        </div>
        <RightNav />
        <Foot />
    </div>
</template>

<script>
import Head from "../components/Head";
import Foot from "../components/Foot";
import Login from "../components/Login";
import RightNav from "../components/RightNav";
// import Page from "../components/Page";
// import HotDetails from "../components/HotDetails";
export default {
    name: "Hotspot",
    data() {
        return {
            total1: 0,
            hotspot: [],
            Page1: 1,
            PageSize1: 10,
            currentIdx: null,
            currentCheckIdx: null,
            eve: true,
            isLogin: false,
            navI: 0,
            hMtop: ["行业动态", "国内动态", "国外动态"],
            news1: [],
        };
    },
    mounted() {
        this.news();
        this.getBanner()
    },
    methods: {
        getBanner() {
            let that = this
            this.$axios
                .post(
                    "banner/info",
                    that.$qs.stringify({
                        banner_id: '4',
                    })
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        this.news1 = res.data.data.list
                    }
                });
        },
        toDel(item) {
            window.open(item.url, "_blank");
        },
        addLink(i, name, id) {
            this.$axios.post("information/clicknums?ID=" + id);
            document.getElementsByClassName(name)[i].classList.add("m");
        },
        async news() {
            let _this = this;
            await _this.$axios
                .post(
                    `information/index?Type=1&provinceid=37&status=0&page=${this.Page1}&num=${this.PageSize1}`
                )
                .then((res) => {
                    console.log(res.data.data.list);
                    if (res.data.code == 10000) {
                        _this.total1 = res.data.data.total_num;
                        this.hotspot.push(res.data.data.list);
                    }
                });
            // await _this.$axios
            //     .post(
            //         _this.$URL +
            //             `/information/index?Type=2&provinceid=37&status=0&page=${this.Page1}&num=${this.PageSize1}`
            //     )
            //     .then((res) => {
            //         console.log(res.data.data.list);
            //         if (res.data.code == 10000) {
            //             _this.total1 += res.data.data.total_num;
            //             this.hotspot.push(res.data.data.list);
            //         }
            //     });
            // await _this.$axios
            //     .post(
            //         _this.$URL +
            //             `/information/index?Type=3&provinceid=37&status=0&page=${this.Page1}&num=${this.PageSize1}`
            //     )
            //     .then((res) => {
            //         console.log(res.data.data.list);
            //         if (res.data.code == 10000) {
            //             _this.total1 += res.data.data.total_num;
            //             this.hotspot.push(res.data.data.list);
            //         }
            //     });
        },
        getNav(i) {
            if (i != undefined) {
                this.navI = i;
                this.Page1 = 1;
            }
            console.log(this.navI);
            let _this = this;
            _this.$axios
                .post(
                    `information/index?Type=${Number(this.navI) + 1}&provinceid=37&status=0&page=${this.Page1}&num=${this.PageSize1
                    }`
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        _this.total1 = res.data.data.total_num;
                        // _this.hotspot[i]=res.data.data.list
                        _this.$set(_this.hotspot, this.navI, res.data.data.list);
                    }
                });
        },
        details(navI, index) {
            this.currentCheckIdx = index;
            let routeUrl = this.$router.resolve({
                path: "/Hotspot/HotDetails",
                query: { id: navI, news: index },
            });
            window.open(routeUrl.href, "_blank");
        },
        isLoginOpen(e) {
            this.isLogin = e;
        },
        bianse(index) {
            this.currentIdx = index;
        },
        yuanse() {
            this.currentIdx = null;
        },
    },
    components: {
        Head,
        Foot,
        Login,
        // Page
        // HotDetails
        RightNav,
    },
};
</script>
<style lang="less" scoped>
#Hotspot {
    width: 100%;
    min-width: 1000px;

    .hotspot {
        width: 100%;
        padding: 0 1.35rem;
        margin-top: 0.4rem;

        .Main {
            width: 100%;
            display: flex;
            justify-content: space-between;

            .banner {
                width: 100%;
                margin-top: 0.2rem;

                img {
                    height: 100%;
                    width: 100%;
                }
            }

            .news {
                height: 0.34rem;
                width: 3.5rem;

                p {
                    font-size: 0.22rem;
                    margin: 0.3rem 0 0.1rem 0.1rem;
                }

                .rec {
                    li {
                        position: relative;
                        cursor: pointer;

                        b {
                            width: 100%;
                            height: 0.3rem;
                            line-height: 0.3rem;
                            background-color: rgba(0, 0, 0, 0.5);
                            font-size: 0.12rem;
                            position: absolute;
                            left: 0;
                            bottom: 0.05rem;
                            text-align: center;
                            color: #fff;
                        }
                    }

                    img {
                        width: 100%;
                        height: 2rem;
                    }
                }
            }

            .hNav {
                // margin-top: 0.8rem;
                width: 3.5rem;
                border: 0.01rem solid #ababab;

                // margin-bottom: 0.3rem;
                .hNTop {
                    width: 100%;
                    height: 0.6rem;
                    background: #3f6bc2;
                    font-size: 0.25rem;
                    // display: flex;
                    // align-items: center;
                    text-align: center;
                    line-height: 0.6rem;
                    font-weight: 550;
                    color: white;
                    padding: 0 0.8rem;
                    // justify-content: space-between;
                    // i {
                    //   display: inline-block;
                    //   background-image: url("../assets/Hotspot/组 15 拷贝.png");
                    //   background-size: 100%;
                    //   background-repeat: no-repeat;
                    //   background-position: center;
                    //   width: 0.4rem;
                    //   height: 0.4rem;
                    // }

                    >img {
                        margin-left: 0.1rem;
                        margin-right: 0.2rem;
                        width: 0.3rem;
                    }
                }

                ul {
                    width: 100%;

                    li {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        font-size: 0.2rem;
                        padding: 0.16rem;
                        margin-top: 0.05rem;
                        border-bottom: 0.01rem solid #f1f1f1;
                        cursor: pointer;

                        &.active {
                            background: #84c7fa;
                            color: #ffffff;
                        }

                        img {
                            // display: inline-block;
                            width: 0.24rem;
                            height: 0.24rem;
                            // margin-left: 0.2rem;
                            margin-right: 0.2rem;
                        }
                    }
                }
            }

            .hMain {
                position: relative;
                min-height: 10.5rem;
                width: calc(100% - 3.85rem);
                height: 100%;
                border: 0.01rem solid #ababab;
                padding: 0.15rem;

                .hMtop {
                    font-size: 0.22rem;
                    position: relative;
                    line-height: 0.35rem;
                    padding-left: 0.1rem;

                    >img {
                        display: block;
                        position: absolute;
                        left: 0.05rem;
                        width: 1rem;
                    }
                }

                .hMList {
                    margin-top: 0.2rem;
                    width: 100%;
                    padding-bottom: 0.5rem;

                    >ul {
                        width: 100%;

                        li {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-bottom: 0.3rem;

                            img {
                                width: 2.68rem;
                                height: 1.46rem;
                                display: block;
                                margin-right: 0.1rem;
                                flex-shrink: 0;
                            }

                            >div {
                                width: 100%;
                                height: 0.46rem;
                                line-height: 0.46rem;

                                .activeColor {
                                    color: #3f6bc2;
                                }

                                .activeColor1 {
                                    color: #3f6bc2;
                                }

                                a:-webkit-any-link {
                                    color: #000;
                                }

                                a.m:visited {
                                    color: orange;
                                }

                                a:hover {
                                    color: #3f6bc2;
                                }

                                .hMTitle {
                                    width: 100%;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    font-size: 0.18rem;

                                    i {
                                        margin-right: 0.1rem;
                                        display: inline-block;
                                        width: 0.1rem;
                                        height: 0.1rem;
                                        border-radius: 50%;
                                        background: #ccc;
                                    }

                                    .active1 {
                                        background: #3f6bc2;
                                    }

                                    .active {
                                        background: #3f6bc2;
                                    }

                                    span {
                                        font-size: 0.16rem;
                                        // color: #c5c4c4;
                                    }
                                }

                                .hMText {
                                    width: 6.7rem;
                                    font-size: 0.16rem;
                                    margin-top: 0.3rem;
                                    color: #ababab;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 3;
                                    /*超出3行部分显示省略号，去掉该属性 显示全部*/
                                    -webkit-box-orient: vertical;
                                }
                            }
                        }
                    }
                }

                .hMFoot {
                    width: calc(100% - 0.3rem);
                    height: 0.5rem;
                    position: absolute;
                    left: 0.15rem;
                    bottom: 0.15rem;
                }
            }
        }
    }
}
</style>
